import React from 'react';
import { Alert } from '@material-ui/lab';
import { mdiCheck, mdiClose } from '@mdi/js';
import Icon from '@mdi/react';
import styled from 'styled-components';
import { IconSize } from '../../../../../lib';
const StyledAlert = styled(Alert) `
    margin-bottom: 1rem;
    padding: 0 1rem;

    display: flex;
    align-items: center;

    svg {
        width: ${IconSize.Medium};
        height: ${IconSize.Medium};
    }
`;
export var QuestionResultStatus;
(function (QuestionResultStatus) {
    QuestionResultStatus["Unanswered"] = "Unanswered";
    QuestionResultStatus["Correct"] = "Correct";
    QuestionResultStatus["Incorrect"] = "Incorrect";
})(QuestionResultStatus || (QuestionResultStatus = {}));
const QuestionViewerResult = ({ status = QuestionResultStatus.Unanswered, action, hint }) => {
    switch (status) {
        case QuestionResultStatus.Unanswered:
        default:
            return null;
        case QuestionResultStatus.Correct:
            return (React.createElement(StyledAlert, { action: action, icon: React.createElement(Icon, { path: mdiCheck }), severity: "success", "data-testid": "questionResult-correct" }, "Correct!"));
        case QuestionResultStatus.Incorrect:
            return (React.createElement(StyledAlert, { action: action, icon: React.createElement(Icon, { path: mdiClose }), severity: "error", "data-testid": "questionResult-incorrect" },
                "Incorrect. ",
                hint ? React.createElement("i", null,
                    "Hint: ",
                    hint) : null));
    }
};
export default QuestionViewerResult;
//# sourceMappingURL=index.js.map